import { useRef } from 'react';
import { CASES } from './data';

export default function CasesCarousel() {
  const scrollerRef = useRef<HTMLDivElement>(null);

  const scrollByAmount = (direction: number) => {
    const node = scrollerRef.current;
    if (!node) return;
    node.scrollBy({ left: direction * node.clientWidth * 0.8, behavior: 'smooth' });
  };

  return (
    <section id="cases" className="scroll-mt-28 overflow-hidden bg-secondary-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Histórias reais
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Empresas que transformam <span className="text-primary-600">reconhecimento em performance</span>
          </h2>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={() => scrollByAmount(-1)}
            aria-label="Case anterior"
            className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-colors hover:bg-primary-50"
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollByAmount(1)}
            aria-label="Próximo case"
            className="flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-colors hover:bg-primary-50"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      <div ref={scrollerRef} className="lp-scroll-hide mt-6 flex snap-x snap-mandatory gap-5 overflow-x-auto px-6 pb-2">
        {CASES.map((item) => (
          <article
            key={item.tag}
            className="flex w-[86vw] max-w-[680px] shrink-0 snap-start flex-col justify-between gap-6 rounded-3xl border border-background-200 bg-background-50 p-7 md:p-10"
          >
            <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-primary-700">{item.tag}</span>
            <p className="font-heading text-lg leading-snug text-foreground-900 md:text-2xl">{item.quote}</p>
            <div className="flex flex-wrap items-end gap-6">
              <span className="font-heading text-4xl font-bold leading-none text-accent-600 md:text-5xl">{item.metric}</span>
              <span className="max-w-[220px] pb-1 text-sm leading-snug text-foreground-600">{item.metricLabel}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}